import CartItem from '@/classes/CartObject';

class SkiRentalCartItem extends CartItem {
  type = 'SKIRENTAL';

  guideCompleted = false;

  name = '';
  age = 0;
  category = '';
  subCategory = '';
  type = '';
  searchPackage = '';

  days = 0;
  startDate = null;

  priceType = 'day';

  products = [];
  addons = [];

  lengthCm = null;
  weight = null;
  shoeSize = null;
  jacketsize = null;
  pantsize = null;

  possibleAddons = [];

  delivery = false;
  site = null;
  insurance = null;

  editing = false;

  editableQuantity = false;

  wishes = {
    wideCalf: false,
    wideFoot: false,
    softShoes: false,
    hardShoes: false,
    shortTurn: false,
    longTurn: false,
    startSki: false,
    startSnowboard: false,
    preferedFootLeft: false,
    preferedFootRight: false,
    freeText: '',
  };

  constructor() {
    super();
    return true;
  }
}

export default SkiRentalCartItem;



// WEBPACK FOOTER //
// ./src/classes/SkiRentalCartItem.js